// extracted by mini-css-extract-plugin
export var dropdown = "_v8-0";
export var imageWrapper = "_v8-3";
export var itemNameContainer = "_v8-1";
export var productImage = "_v8-2";
export var spinnerWrapper = "_v8-4";